// @ts-nocheck
/* eslint-enable */
import cx from 'classnames';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import './style.scss';
import { textOverflow } from 'app/shared/styles/_mixins';
import appUtils from 'app/shared/utils/appUtils';
import AppActions from 'app/shared/flux/actions/AppActions';
import Text from 'app/shared/core/Text';
import constants from 'app/shared/constants/ValueConstants';
import { useYieldCallback } from '@zillow/yield-callback';

const { bool, func, string } = PropTypes;
const MODAL_WIDTH = 336;
const StyledOverflowDiv = styled.div`
  ${textOverflow};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const ButtonDropdownV2 = ({
  className = '',
  dropdownRight = false,
  forceOverlay = true,
  forceNoOverlay = false,
  isOpen: isOpenProp = false,
  label = '',
  onClose = () => {},
  noBorder = false,
  size = 'sm',
  theme = 'default',
  filterModalName,
  handleClick,
  ...props
}) => {
  const dispatch = useDispatch();
  const ButtonDropdownV2Ref = useRef(null);
  const showFilterModal = useSelector((state) => state.app.showFilterModal);
  const isOpen = showFilterModal === filterModalName;
  const rest = omit(props, [
    'dispatch',
    'filter',
    'filterKeys',
    'onClick',
    'showDoneButton',
    'showFilterModal',
    'zIndexOnTop',
  ]);

  const calculateOffset = useCallback(() => {
    const nodeCoords = ButtonDropdownV2Ref.current.getBoundingClientRect();

    // If 'PetsSelector' modal is displayed, right align with dropdown button
    // so it doesn't flow off the side of the viewport.
    if (filterModalName === 'PetsSelector') {
      return Math.floor(nodeCoords.left + nodeCoords.width) - MODAL_WIDTH;
    } else {
      return Math.floor(nodeCoords.left);
    }
  }, [filterModalName]);

  useEffect(() => {
    if (filterModalName === showFilterModal) {
      const offsetX = calculateOffset();
    }
  }, [calculateOffset, dispatch, filterModalName, showFilterModal]);

  const handleCloseDropdown = useCallback(() => {
    appUtils.unlockVerticalScrolling();
    dispatch(AppActions.setAppStoreBool('showFilterModal', false));
  }, [dispatch]);

  const yieldSetAppStoreBool = useYieldCallback((name, boolValue) => {
    dispatch(AppActions.setAppStoreBool(name, boolValue));
  });

  const yieldHandleClickToggle = useYieldCallback(() => {
    // TODO: **ALL** of the following logic should be decoupled from this component and moved
    // into a parent component where this is called.

    if (showFilterModal && showFilterModal !== filterModalName) {
      handleCloseDropdown();
      appUtils.lockVerticalScrolling();
      yieldSetAppStoreBool('showFilterModal', filterModalName);
    } else if (!showFilterModal && showFilterModal !== filterModalName) {
      appUtils.lockVerticalScrolling();
      yieldSetAppStoreBool('showFilterModal', filterModalName);
    } else {
      handleCloseDropdown();
    }
  }, [calculateOffset, dispatch, filterModalName, handleCloseDropdown, props, showFilterModal]);

  const handleClickToggle = useCallback(() => {
    if (handleClick) {
      handleClick();
      return;
    }
    yieldHandleClickToggle();
  }, [yieldHandleClickToggle, handleClick]);

  const handleKeyDown = useCallback(
    ({ key, altKey }) => {
      if (
        key === constants.ESC_KEYCODE ||
        key === constants.ENTER_KEYCODE ||
        key === constants.SPACE_KEYCODE ||
        (key === constants.DOWN_ARROW_KEYCODE && altKey)
      ) {
        handleClickToggle();
      }
    },
    [handleClickToggle],
  );

  return (
    <button
      aria-expanded={isOpen}
      ref={ButtonDropdownV2Ref}
      className={cx('ButtonDropdownV2', className, {
        active: isOpen,
        'ButtonDropdownV2-gray-theme': theme === 'gray',
        'ButtonDropdownV2-teal-theme': theme === 'teal',
      })}
      onClick={handleClickToggle}
      onKeyDown={handleKeyDown}
      {...rest}
    >
      <StyledOverflowDiv className="ButtonDropdownV2-clickable">
        {label && (
          <Text
            size={size === 'lg' ? 'md' : 'sm'}
            className={cx('ButtonDropdownV2-text', {
              'ButtonDropdownV2-text-teal-theme': theme === 'teal',
            })}
          >
            {label}
          </Text>
        )}
      </StyledOverflowDiv>
    </button>
  );
};

ButtonDropdownV2.propTypes = {
  className: string,
  dropdownRight: bool,
  forceOverlay: bool,
  forceNoOverlay: bool,
  handleClick: func,
  isOpen: bool,
  label: string,
  noBorder: bool,
  onClose: func,
  size: string,
  theme: string,
};

export default ButtonDropdownV2;
